// removed by extract-text-webpack-plugin
module.exports = {"registration-guide-page":"registration-guide-page","guide-page-container":"guide-page-container"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/RegistrationGuide/RegistrationGuidePage.scss
// module id = 4396
// module chunks = 1